import { render } from "./PostsPassportHistoryTable.vue?vue&type=template&id=402c5d2a&scoped=true"
import script from "./PostsPassportHistoryTable.vue?vue&type=script&lang=js"
export * from "./PostsPassportHistoryTable.vue?vue&type=script&lang=js"

import "@/assets/table.css?vue&type=style&index=0&id=402c5d2a&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-402c5d2a"]])

export default __exports__